module.exports = __webpack_public_path__ + "img/234.64723e61.jpg";